<div *ngIf="project">

   <div class="highligth">
      <div class="title"><span>{{ project.name }}</span></div>
      <div>
         <img [src]="buildImageUrl(project, urlBaseS3)" alt="#">
      </div>
   </div>

   <div class="container p-4 mt-2 mb-5">
      <div class="row">
         <div class="col-12 col-md-7 col-lg-6">
            <div class="box d-flex flex-column flex-sm-row justify-content-between p-4 mb-4">
               <div class="me-0 me-md-3">
                  <p class="fs-16 cl-neutral-1 fw-sbold mb-2">Participación {{ project.name }}</p>
                  <div class="d-flex fs-13 cl-primary-7 mb-2">
                     Participaciones disponibles: <p class="fw-sbold ms-2 mb-0">{{ project.free | number }}</p>
                  </div>

                  <div class="d-flex align-items-center justify-content-between m-0">
                     <div>
                        <p class="fs-13 cl-primary-7 m-0">
                           Participaciones que aún puedes adquirir: <span class="fw-sbold ms-1"> {{ totalFreePerUser | number }}</span>
                        </p>
                     </div>
                     <div class="ms-2">
                        <p class="m-0 cl-primary-7" (click)="showInfo()">▼</p>
                     </div>
                  </div>

                  <div *ngIf="showInfoParts" class="animated fadeIn">
                     <hr>
                     <div class="d-flex fs-11 cl-primary-7 mb-2 align-items-center">
                        Participaciones máximas por usuario:<p class="fw-sbold ms-1 mb-0" *ngIf="!userWithoutPurchaseLimit">{{ project.limit | number }}</p>
                        <p class="fw-sbold ms-1 mb-0" *ngIf="userWithoutPurchaseLimit">Sin Límite</p>
                        <i class="mnf-explain-border ms-1" matTooltip="Máximo 5% del Valor del Proyecto"
                           matTooltipPosition="right"  *ngIf="!userWithoutPurchaseLimit"></i>
                        <i class="mnf-explain-border ms-1" matTooltip="No se aplican límites de compra para tu usuario"
                           matTooltipPosition="right"  *ngIf="userWithoutPurchaseLimit"></i>
                     </div>
                     <p class="d-flex fs-11 cl-primary-7 mb-2 align-items-center">
                        Participaciones ya adquiridas en este proyecto: <span class="fw-sbold ms-1"> {{ partsActual | number }}</span>
                     </p>
                  </div>
               </div>

               <div class="count justify-content-around justify-content-md-start">
                  <form [formGroup]="partsForm" (change)="getValue()" class="d-flex align-items-center">
                     <i class="mnf-minus fs-7 adjust" (click)="minusAmount()"></i>
                     <input type="number" class="input-parts" formControlName="partsToBuy"
                        [maxLength]="project.amount" [minlength]="1"
                        (keyup)="updateInRealTimeKeyPress($event.target)">
                     <i class="mnf-plus fs-17 adjust" (click)="plusAmount()"></i>
                  </form>
               </div>
            </div>

            <div class="box p-4 mb-4">

               <div *ngIf="project?.actualState === 'in-construction' && project?.discount">
                  <div class="d-flex align-items-center justify-content-between my-1">
                     <p>Descuento inmediato por preventa <strong>({{project?.discount|percent}})</strong></p>
                     <p class="cl-primary-7 fw-bold">{{ discountImmediately | number }}</p>
                  </div>
                  <hr>
               </div>


               <p class="fs-15 cl-neutral-1 mb-1 fw-sbold">Cálculo de rendimientos:</p>

               <div class="d-flex justify-content-between">
                  <p class="mb-2">Inversión:</p>
                  <p class="mb-2 fw-sbold">$ {{ totalToPay | number }}</p>
               </div>

               <hr>

               <div class="d-flex justify-content-between">
                  <p class="fs-15 cl-neutral-1 mb-1 fw-sbold mb-2" *ngIf="project.actualState == 'fixed'">Rendimiento anual fijo:</p>
                  <p class="fs-15 cl-neutral-1 mb-1 fw-sbold mb-2" *ngIf="project.actualState == 'variable'">TIR anual estimada:</p>
                  <p class="mb-0 fw-sbold cl-primary-7">$ {{ estimatedPerformance | number }} </p>
               </div>

               <p class="cl-primary-4 fs-13 mb-0 mt-4">
                  Si inviertes <span class="fw-sbold fs-15">$ {{ totalToPay | number }}</span>
                  ganaras <span class="fw-sbold fs-15">$ {{estimatedPerformance | number }} </span> 
                  <span> en rendimientos anuales</span>
                  <br>
                  <a class="m-0 link-s fw-sbold "
                     href="https://centrodeayuda.monific.com/c%C3%B3mo-obtengo-rendimientos-en-proyectos-de-rendimiento-fijo-en-monific"
                     target="_blank"> Leer más</a>
               </p>
            </div>

         </div>

         <div class="col-12 col-md-5 col-lg-4">
            <div class="box p-4">

               <div class="d-flex justify-content-between">
                  <p class="mb-2">Participaciones a adquirir:</p>
                  <p class="mb-2 fw-sbold">{{ selectedAmountByForm }}</p>
               </div>

               <div class="d-flex justify-content-between">
                  <p class="mb-2">Precio unitario:</p>
                  <p class="mb-2 fw-sbold">$ {{ project.partValue | number }}</p>
               </div>

               <hr>

               <div class="d-flex justify-content-between mb-4">
                  <p class="fs-15 cl-neutral-1 mb-1 fw-sbold my-auto">Total:</p>
                  <p class="mb-0 fs-20 fw-sbold cl-primary-7">$ {{ totalToPay | number }}</p>
               </div>

               <div class="text-center">
                  <button mat-button class="mb-4 w-75" (click)="next()"
                     [disabled]="selectedAmountByForm > totalFreePerUser">Invertir ahora</button>
               </div>

               <p class="mb-0 fs-11 cl-neutral-3">Saldo restante después de ésta compra:
                  <span >$ {{ totalAfterPurchase | number}} </span></p>
            </div>
         </div>

      </div>
   </div>

</div>
